
import React from 'react';
import StructuredData from '@/components/StructuredData';
import { Site } from '@/services/types';
import { formatOpeningHours } from './openingHoursUtils';

interface LocalBusinessSEOSchemaProps {
  sites: Site[];
  isDeptPage?: boolean;
  deptName?: string;
}

const LocalBusinessSEOSchema: React.FC<LocalBusinessSEOSchemaProps> = ({ 
  sites, 
  isDeptPage, 
  deptName 
}) => {
  // Schémas LocalBusiness pour chaque site
  const localBusinessSchemas = sites.map(site => ({
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `https://www.groupefabre-environnement.fr/sites/${site.id}#localbusiness`,
    "name": site.name,
    "description": site.description || `Centre de recyclage et gestion des déchets ${site.name} à ${site.city}`,
    "url": `https://www.groupefabre-environnement.fr/sites/${site.id}`,
    "telephone": site.phone,
    "email": site.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": site.address,
      "addressLocality": site.city,
      "postalCode": site.postalCode,
      "addressRegion": isDeptPage ? deptName : undefined,
      "addressCountry": "FR"
    },
    "geo": (site.coordinates && site.coordinates.lat && site.coordinates.lng) ? {
      "@type": "GeoCoordinates",
      "latitude": site.coordinates.lat,
      "longitude": site.coordinates.lng
    } : undefined,
    "openingHoursSpecification": formatOpeningHours(site.opening_hours),
    "serviceType": site.services || ["Gestion des déchets", "Recyclage", "Location de bennes"],
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": (site.coordinates && site.coordinates.lat && site.coordinates.lng) ? {
        "@type": "GeoCoordinates",
        "latitude": site.coordinates.lat,
        "longitude": site.coordinates.lng
      } : undefined,
      "geoRadius": "50000"
    },
    "priceRange": "€€",
    "paymentAccepted": ["Cash", "Credit Card", "Invoice"],
    "currenciesAccepted": "EUR"
  }));

  return <StructuredData data={localBusinessSchemas} />;
};

export default LocalBusinessSEOSchema;
